import { CREDIT_NOTE_STATUS_LABEL, CREDIT_NOTE_STATUS_TONE } from '../../Enums/money-out.enum';
import { CreditNoteResponse } from '../../Interfaces/api/backoffice/billing-document.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class CreditNote {
  id = '';
  invoice_id = '';
  stripe_credit_note_id: string | null = null;
  amount = 0;
  currency: string | null = null;
  reason: string | null = null;
  status: string | null = null;
  refunded = false;
  created_by: string | null = null;
  created_at: string | null = null;

  constructor(data: Partial<CreditNoteResponse> = {}) {
    Object.assign(this, data);
  }

  get statusLabelKey(): string {
    return this.status ? (CREDIT_NOTE_STATUS_LABEL[this.status] ?? this.status) : '';
  }

  get statusTone(): StatusTone {
    return this.status ? (CREDIT_NOTE_STATUS_TONE[this.status] ?? 'neutral') : 'neutral';
  }
}
